export const isWrapperApp = Boolean(
    (window as any)?.webkit?.messageHandlers?.callbackHandler?.postMessage || (window as any)?.nativeWrapper
);
